import { apiRequest, ticketDetail } from "../../../../services/adapters/base";

class DetailRepository {
	fetchDetail = async (query) => {
		return await apiRequest(
			"get",
			ticketDetail,
			{
				params: query,
			},
			true
		);
	};
}

export default DetailRepository;
